import { useContext, useState } from 'react';
import { Card, Container, CardHeader, Typography, Button, CardContent, Grid, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';
import { useLocation } from 'react-router';


let ResetPassword = () => {
    let location = useLocation<any>();

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);

    let resetPasswordSchema = yup.object().shape({
        code: yup.string().default('').required("Wrong code"),
        email: yup.string().default('').required("Email is mandatory"),
        password: yup.string().default('').required("You have to provide new password"),
        passwordConfirm: yup.string()
            .oneOf([yup.ref('password'), null], "Passwords does not match")
            .required("You have to confirm new password")
            .default('')
    })


    return (
        <Container maxWidth="sm">
            <Card elevation={0}>
                <CardHeader
                    disableTypography
                    title={<Typography variant="h4">Reset password</Typography>}
                    subheader={<Typography variant="h5">Please set the code that we have sent to your email and new password</Typography>}
                />

                <CardContent style={{ padding: 0 }}>
                    <Grid container>
                        <Grid item xs>
                            <Formik
                                initialValues={{
                                    ...resetPasswordSchema.getDefault(),
                                    email: location.state?.email || ''
                                }}
                                validationSchema={resetPasswordSchema}
                                onSubmit={async (values, action) => {
                                    setLoading(true);
                                    await authService.forgotPasswordSubmit(values.email, values.code, values.password);
                                }}
                            >
                                <Form>
                                    <Grid container alignItems="center">
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="email"
                                                label="Email"
                                                variant="outlined"
                                                fullWidth
                                                type="email"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="code"
                                                label="Code"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="password"
                                                label="Password"
                                                variant="outlined"
                                                fullWidth
                                                type="password"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="passwordConfirm"
                                                label="Confirm Password"
                                                variant="outlined"
                                                fullWidth
                                                type="password"
                                            />
                                        </Grid>
                                        <Grid item xs>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading}
                                                startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                            >
                                                Reset password
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Formik>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    )
}

export default ResetPassword;